
export default function AboutStats() {
  const stats = [
    {
      number: '2500+',
      label: 'Clients Satisfaits',
      icon: 'ri-user-heart-line'
    },
    {
      number: '15000+',
      label: 'Équipements Installés',
      icon: 'ri-camera-line'
    },
    {
      number: '20+',
      label: 'Techniciens Experts',
      icon: 'ri-team-line'
    },
    {
      number: '24h/7j',
      label: 'Support Technique',
      icon: 'ri-customer-service-line'
    },
    {
      number: '99.8%',
      label: 'Taux de Satisfaction',
      icon: 'ri-star-line'
    },
    {
      number: '2 ans',
      label: 'Garantie Moyenne',
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Cobra Sécurité en <span className="text-red-500">Chiffres</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Des résultats qui témoignent de notre expertise et de la confiance de nos clients
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-20 h-20 bg-red-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className={`${stat.icon} text-white text-3xl`}></i>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">{stat.number}</div>
              <div className="text-gray-300 text-lg">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
